import { TREATMENT_CATEGORIES, TREATMENTS } from "../data/site";

export const PriceList = () => (
  <div className="grid grid-cols-1 gap-x-16 gap-y-14 md:grid-cols-2" data-testid="price-list">
    {TREATMENT_CATEGORIES.map((c, ci) => (
      <div key={c.id} data-testid={`price-group-${c.id}`}>
        <div className="flex items-baseline gap-4 border-b-2 border-primary/70 pb-3">
          <span className="font-display text-sm italic text-primary/50">{String(ci + 1).padStart(2, "0")}</span>
          <h3 className="font-display text-2xl font-light tracking-tight">{c.label}</h3>
        </div>
        <ul>
          {TREATMENTS.filter((t) => t.category === c.id).map((t) =>
            t.pricing.map((p, pi) => (
              <li
                key={`${t.id}-${pi}`}
                className="flex items-baseline justify-between gap-6 border-b border-border/60 py-2.5"
                data-testid={`price-row-${t.id}-${pi}`}
              >
                <span className="text-sm font-light text-foreground/85">
                  {t.name}
                  {t.pricing.length > 1 && p.label ? (
                    <span className="text-muted-foreground"> · {p.label}</span>
                  ) : null}
                </span>
                <span className="shrink-0 font-display text-lg">{p.price}</span>
              </li>
            ))
          )}
        </ul>
      </div>
    ))}
  </div>
);
